import { Helmet } from 'react-helmet';

import { PageKey } from '../enums/pageKey';
import { getPageSEO } from '../utils/seo';

interface SEOProps {
  pageKey?: PageKey;
  title?: string;
  description?: string;
  ogTitle?: string;
  ogDescription?: string;
  noIndex?: boolean;
}

export default function SEO({
  pageKey,
  title,
  description,
  ogTitle,
  ogDescription,
  noIndex = false,
}: SEOProps): JSX.Element {
  let seoTitle = title;
  let seoDescription = description;
  if (pageKey) {
    const pageSEO = getPageSEO(pageKey);
    seoTitle = title || pageSEO.title;
    seoDescription = description || pageSEO.description;
  }

  return (
    <Helmet>
      <title>{seoTitle}</title>
      <meta key="desc" content={seoDescription} name="description" />
      <meta content={ogTitle || seoTitle} property="og:title" />
      <meta
        key="og:desc"
        content={ogDescription || seoDescription}
        property="og:description"
      />
      <meta content={noIndex ? 'noindex, nofollow' : 'all'} name="robots" />
    </Helmet>
  );
}
